import 'react-app-polyfill/ie11';
import 'core-js/es/string';
import 'core-js/es/array';
import 'core-js/es/object';
import 'core-js/es/set';
import 'reflect-metadata';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import {persistor, store} from './redux/store';
import {BrowserRouter as Router} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';
import App from "./App";

import UILoader from './UILoader';

const Root = () => {
    // Define a fallback component
    const FallbackComponent = () => <div>Loading...</div>;

    return (
        <Suspense fallback={<FallbackComponent />}>
            <App />
        </Suspense>
    );
  };

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Router basename="/profile">
                <Root/>
                {/* <UILoader/> */}
            </Router>
        </PersistGate>
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// tslint:disable-next-line:no-console
console.log('React Accounts :: ENV VARS', `${JSON.stringify(process.env, null, 2)}`);